import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import NavLink from 'react-router-dom/NavLink';

import { Navigation, Wrapper } from 'components/shared';
import { APP_NAME } from 'constants/views';
import { INDEX_PATH } from 'constants/routes';

import logo from 'components/shared/LogoImage/logo-white.png';

function Header() {
  return (
    <Wrapper>
      <HeaderContainer>
        <HeaderLogo to={INDEX_PATH}>
          <LogoImg src={logo} alt={APP_NAME} />
        </HeaderLogo>
        <HeaderNavigation>
          <Navigation />
        </HeaderNavigation>
      </HeaderContainer>
    </Wrapper>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  ${media.lessThan('medium')`
    display: flex;
    padding: 10px 0;
  `};
`;

const HeaderNavigation = styled.div`
  ${media.lessThan('medium')`
    display: block;
    text-align: center;
  `};
`;

const HeaderLogo = styled(NavLink).attrs({})`
  display: flex;
  align-items: center;
  width: 150px;
  height: 38px;
  text-decoration: none;
`;
const LogoImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-height: 38px;
  object-fit: contain;
`;

export default Header;
